import React from 'react';

import { Button, Typography } from '@material-ui/core';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import * as Actions from '../../../weborder/actions/Actions';
import * as Api from '../../../weborder/Api';
import * as Store from '../../../weborder/Store';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type OuterProps = {
  pickupLocationOptions: Api.PickupLocationOption[];
  serviceTypes: {
    isDelivery: boolean;
    isDineInAndTakeOut: boolean;
    isDriveThrough: boolean;
    isDriveThroughOnly: boolean;
    isTableServiceAndTakeOut: boolean;
    isTableServiceOnly: boolean;
  };
  tableNumber: number;
  tableServiceCategory: number;
  toggleModal: () => void;
  vrid: number;
};
type Props = OuterProps & StateProps & DispatchProps;

const SelectServiceButtons = (props: Props): JSX.Element => {
  const {
    editPickupLocationTypes,
    pickupLocationOptions,
    tableNumber,
    tableServiceCategory,
    toggleModal,
    translate,
    vrid,
  } = props;

  const {
    isDelivery,
    isDineInAndTakeOut,
    isDriveThrough,
    isDriveThroughOnly,
    isTableServiceAndTakeOut,
    isTableServiceOnly,
  } = props.serviceTypes;

  const getButtonText = () => {
    switch (tableServiceCategory) {
      case Api.TableServiceCategory.Gate:
        return translate('Gate_delivery');
      case Api.TableServiceCategory.DriveThrough:
        return translate('Drive_Through');
      default:
        return translate('Dine_in');
    }
  };

  const getButtonSubtext = () => {
    if (isDriveThrough) {
      return translate('Pick_up_at_drive_through');
    }

    if (typeof tableNumber !== 'number') {
      return translate(`Select_table_${tableServiceCategory}`);
    }

    if (pickupLocationOptions) {
      return (
        pickupLocationOptions.find(
          (option) => option.PickupLocationOptionId === tableNumber,
        ).Value ||
        `${translate(`Table_${tableServiceCategory}`)} ${tableNumber}`
      );
    }
    return `${translate(`Table_${tableServiceCategory}`)} ${tableNumber}`;
  };

  if (isDelivery || isDriveThroughOnly) {
    return null;
  }

  if (isTableServiceOnly) {
    return (
      <Button onClick={toggleModal} key="table-select-button">
        {getButtonSubtext()}
      </Button>
    );
  }

  if (isDineInAndTakeOut) {
    return (
      <div>
        <Button
          onClick={() => {
            editPickupLocationTypes(vrid, Api.PickupLocationType.DineIn);
          }}
          key="table-select-button"
        >
          <Typography>{getButtonText()}</Typography>
        </Button>
        <Button
          onClick={() => {
            editPickupLocationTypes(vrid, Api.PickupLocationType.TakeOut);
          }}
          key="table-select-button-two"
        >
          <Typography>{translate('Take_out')}</Typography>
        </Button>
      </div>
    );
  }

  if (isTableServiceAndTakeOut) {
    return (
      <div>
        <Button
          onClick={() => {
            editPickupLocationTypes(vrid, Api.PickupLocationType.TableService);
            if (!isDriveThrough) {
              toggleModal();
            }
          }}
          key="table-select-button"
        >
          <Typography>{getButtonText()}</Typography>
          <Typography>{getButtonSubtext()}</Typography>
        </Button>
        <Button
          onClick={() => {
            editPickupLocationTypes(vrid, Api.PickupLocationType.TakeOut);
          }}
        >
          <Typography>{translate('Take_out')}</Typography>
          <Typography>{translate('Collect_counter')}</Typography>
        </Button>
      </div>
    );
  }

  return null;
};

const mapStateToProps = (state: WebOrder.State) => {
  return { translate: getTranslate(state.locale) };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => {
  return {
    editPickupLocationTypes: (vrid: number, value: Api.PickupLocationType) => {
      dispatch(Actions.EditPickupLocationTypes(vrid, value));
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SelectServiceButtons,
);
